import React, { useState } from "react";

export default function ProviderBtn({ icon, label, selected, onClick }) {
  const [isHovered, setIsHovered] = useState(false);
  const [isPressed, setIsPressed] = useState(false);

  return (
    <button
      type="button"
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => {
        setIsHovered(false);
        setIsPressed(false);
      }}
      onMouseDown={() => setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '12px 24px',
        borderRadius: 8,
        fontWeight: 600,
        background: selected
          ? 'linear-gradient(145deg, #f0f7ff 0%, #e0f0ff 100%)'
          : isPressed
            ? 'linear-gradient(145deg, #e0e0e0 0%, #d0d0d0 100%)'
            : isHovered
              ? 'linear-gradient(145deg, #ffffff 0%, #f5f5f5 100%)'
              : 'linear-gradient(145deg, #ffffff 0%, #f8f8f8 100%)',
        color: selected ? '#0078D4' : '#222',
        border: selected 
          ? '2px solid #0078D4' 
          : '1px solid #d0d0d0',
        boxShadow: isPressed
          ? 'inset 0 2px 4px rgba(0,0,0,0.15), 0 1px 2px rgba(0,0,0,0.05)'
          : selected
            ? '0 8px 24px rgba(0,120,212,0.25), 0 4px 8px rgba(0,120,212,0.15), inset 0 1px 0 rgba(255,255,255,0.3)'
            : isHovered
              ? '0 6px 20px rgba(0,0,0,0.12), 0 3px 6px rgba(0,0,0,0.08), inset 0 1px 0 rgba(255,255,255,0.5)'
              : '0 2px 8px rgba(0,0,0,0.08), inset 0 1px 0 rgba(255,255,255,0.3)',
        cursor: 'pointer',
        outline: 'none',
        fontSize: 16,
        minWidth: '140px',
        justifyContent: 'center',
        margin: '4px',
        transition: 'all 0.2s ease',
        transform: isPressed
          ? 'translateY(2px) scale(0.98)'
          : isHovered
            ? 'translateY(-2px) scale(1.02)'
            : 'translateY(0) scale(1)'
      }}
    >
      {icon}
      {label}
    </button>
  );
}
